import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Loader } from "semantic-ui-react";
import { Button, message, Result, Typography } from "antd";
import axios from "axios";
import { handleResendLink } from "../../../helpers/resendVerification";

function ConfirmedPage(props) {
  const history = useHistory();
  const [content, setContent] = useState({
    status: "success",
    message: "User signed up successfully",
    actions: {
      success: {
        sub: "You will be automatically redirected to login page in 3 seconds  or click on the button below",
        click: () => handleRedirect(),
      },
      info: {
        sub: "Your operation has been executed",
        click: async () => await handleResend(),
      },
    },
  });
  const [processing, setProcessing] = useState(false);

  const { Paragraph } = Typography;

  const handleRedirect = () => {
    return history.push("auth");
  };

  const handleResend = async () => {
    try {
      const token = localStorage.getItem("newToken");
      await handleResendLink(
        axios,
        token,
        setProcessing,
        setContent,
        content,
        message
      );
    } catch (error) {
      return message.error(error.message);
    }
  };
  return (
    <>
      <Result
        status={content.status}
        title={content.message}
        subTitle={content.actions[content.status].sub}
        extra={[
          <Button
            type={"primary"}
            key="console"
            onClick={content.actions.success.click}
          >
            Login
          </Button>,
        ]}
      />
      <Paragraph>
        Didn't receive any email?
        <Button
          type="link"
          color="dodge blue"
          onClick={content.actions.info.click}
        >
          {processing ? <Loader active size="tiny" /> : "Resend email"}
        </Button>
      </Paragraph>
    </>
  );
}

export default ConfirmedPage;
